import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import BigCompanyIcon from "../../../../../media/images/icons/company-big-icon";
import ArrowDownSVG from "../../../../../media/images/icons/arrow-down";
import CopyClipboardIcon from "../../../../../media/images/icons/copy-icon";

export default function ContactInfoBox() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        paddingX: "16px",
        borderRadius: "16px",
        marginTop: "16px",
        border: "1px solid gray",
        display: "flex",
        flexDirection: "column",
        paddingY: "8px",
      }}
    >
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          // border: "1px solid gray",
          backgroundColor: open ? "success.main" : "",
          borderRadius: "10px",
          padding: "12px 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          //   border: "1px solid gray",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <BigCompanyIcon
            color={
              open ? theme.palette.success.light : theme.palette.success.main
            }
          />
          <Typography
            sx={{
              fontWeight: "600",
              color: open ? "#fff" : "success.main",
            }}
          >
            اطلاعات تماس پشتیبانی بازارگاه
          </Typography>
        </Box>
        <ArrowDownSVG
          size={20}
          color={open ? "#fff" : theme.palette.primary.main}
        />
      </Box>
      <Box
        sx={{
          mt: open ? 1 : 0,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",
          borderRadius: "8px",
          backgroundColor: "info.light",
          height: open ? "130px" : "0px",
          paddingY: open ? "8px" : "0px",
          transition: "all 0.3s ease",
          overflow: "hidden",
          paddingX: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography>کمیته نظارت بر شرکت:</Typography>
          <Box
            sx={{
              backgroundColor: "#105DAA",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "3px",
              padding: "3px",
              borderRadius: "4px",
            }}
          >
            <CopyClipboardIcon size={20} color="#fff" />
            <Typography
              sx={{
                fontSize: "12px",
                color: "#fff",
              }}
            >
              کپی آدرس
            </Typography>
          </Box>
        </Box>
        <Typography
          sx={{
            mt: 1,
            color: "#105DAA",
          }}
        >
          استان فلان، شهرستان فلانک، شهر فلانک، خیابان فلان ، صد متری جاده فلان،
          شهرک صنعتی ، سوله ...
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              paddingX: "4px",
              paddingY: "4px",
              borderRadius: "8px",
              justifyContent: "space-between",
              border: "1px solid gray",
            }}
          >
            <Typography
              sx={{
                color: "#105DAA",
              }}
            >
              09999999999{" "}
            </Typography>
            <Box
              sx={{
                backgroundColor: "#105DAA",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "3px",
                padding: "3px",
                borderRadius: "4px",
              }}
            >
              <CopyClipboardIcon size={20} color="#fff" />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#fff",
                }}
              >
                کپی
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              paddingX: "4px",
              paddingY: "4px",
              borderRadius: "8px",
              justifyContent: "space-between",
              border: "1px solid gray",
            }}
          >
            <Typography
              sx={{
                color: "#105DAA",
              }}
            >
              09999999999{" "}
            </Typography>
            <Box
              sx={{
                backgroundColor: "#105DAA",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "3px",
                padding: "3px",
                borderRadius: "4px",
              }}
            >
              <CopyClipboardIcon size={20} color="#fff" />
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#fff",
                }}
              >
                کپی
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
